import { isPlatformBrowser } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
import { ToastrService } from 'ngx-toastr';
import { TicketComponent } from '@app/components/ticket/ticket.component';

@Component({

  selector: 'orders',
  templateUrl: 'orders.component.html',
  styleUrls: ['orders.component.scss'],
  providers: [OrdersService]
})
export class OrdersComponent {
  // @ViewChild('template') template: TemplateRef<any>;
  pdvs: any[] = [];
  pdv: string = "";
  modalRef: BsModalRef;
  dtOptions: any = {};
  rule: boolean = false;
  rule1: boolean = false;
  rulesLabel: String = "MODIFIER COMMANDE";
  rulesLabel1: String = "CREER COMMANDE";
  orders: any[] = [];
  ticket = false;
  order: any = {};
  idOrder2: number = 0;
  user: any = {};
  date: Number;
  constructor(
    private toastr: ToastrService,
    private modalService: BsModalService,
    private ordersService: OrdersService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.getUserOrders();
  }


  getReadyin(d, minDelay) {
    let date = +new Date();
    let dateCmd = +new Date(d);
    var tmp = Math.floor((date - dateCmd) / 60000);
    tmp = (minDelay - tmp > 0) ? minDelay - tmp : 0;
    return tmp;
  }

  ngOnInit() {
  }
  seeTicket(i) {
    this.modalRef = this.modalService.show(TicketComponent, { class: 'modal-ticket' });
    this.modalRef.content.idOrder = this.orders[i].id;
  }

  getUserOrders() {
    this.ordersService.getUserOrders().subscribe(
      (data: any[]) => {
        this.orders = data.sort((a, b) => {
          var dateA = new Date(a.createdAt), dateB = new Date(b.createdAt);
          return dateA < dateB ? 1 : -1;
        });
      }
    )
  }

  payer(i) {
    let total = this.orders[i].total;
    let id = this.orders[i].id;
    this.ordersService.getPayementData(total).subscribe(
      (data: any) => {
        this.ordersService.updateOrderTransaction({ id, transaction: data.id }).subscribe(
          (order) => {
            if (isPlatformBrowser(this.platformId)) {
              window.location.href = data.redirect_url;
            }
          },
          () => {
            this.toastr.error('Erreur de serveur', 'Attention !');
          }
        )
      },
      () => {
        this.toastr.error('Erreur de serveur', 'Attention !');
      }
    )
  }

}
